<template>
  <div class="pos-rel" @dragleave="onFileDragLeave" @dragover="onFileDragOver">
    <v-list-tile
      @click.prevent="clickItem"
      @dblclick.native.prevent="downloadFile"
      :class="activeClass">
      <v-layout align-center row
        class="caption"
        :class="paddingClass"
      >
        <v-flex mr-2 v-if="isAdmin">
          <div class="files_checkbox__spacer"></div>
        </v-flex>
        <FileIcon :mimeType="fileMimeTypeData" />
        <v-flex xs12 md4 lg4
          @mouseover="showTooltip()"
          @mouseout="hideTooltip()"
          ref="nameContainer"
          class="overflow-hidden">
          <div class="css-tooltip">
            <div class="overflow-ellipsis pr-4">
                <div class="overflow-ellipsis__inner">
                  {{file.name}}
                </div>
              </div>
          </div>
        </v-flex>
        <v-flex xs2 class="hidden-sm-and-down">
          {{fileType}}
        </v-flex>
        <v-flex xs2 class="hidden-sm-and-down">
          {{file.created_at}}
        </v-flex>
        <v-flex xs2 md3 lg2 class="hidden-sm-and-down">
          {{file.last_modified_at}}
        </v-flex>
        <v-flex xs2 class="hidden-sm-and-down">
          {{file.size}}
        </v-flex>
      </v-layout>
    </v-list-tile>
    <div class="files_checkbox"
       v-if="isAdmin"
      :class="checkboxMargin"
    >
      <v-checkbox
        color="blue-grey lighten-1"
        :disabled="checkboxDisabled"
        v-model="isActive"></v-checkbox>
    </div>
    <FolderMenu
      :file="file"
    />
    <v-divider v-if="!isLast"></v-divider>
    <div
      ref="toolTipItem"
      class="neti-tooltip neti-tooltip--disabled"
    >
      {{file.name}}
    </div>

    <v-tooltip
      top
      content-class="tooltip-align-left"
      :value="tooltipVisibility"
      :position-x="tooltipPosition.left"
      :position-y="tooltipPosition.top">
      <span></span>
    </v-tooltip>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import FolderMenu from './Menus/FolderMenu.vue';
import FileIcon from './FileIcon.vue';
import { getMimeTypeData, downloadInit, decodeUri } from '../../helpers/helpers';
import { authorizeDownload } from '../../repository/files';

export default {
  name: 'file-item',
  props: ['file', 'index'],
  data: () => ({
    selected: false,
    tooltipVisibility: false,
    tooltipPosition: {
      left: 0,
      top: 0,
    },
  }),
  components: {
    FileIcon,
    FolderMenu,
  },
  computed: {
    ...mapGetters('files', [
      'filesList',
      'selectedFiles',
    ]),
    ...mapGetters('user', [
      'details',
      'role',
    ]),
    tooltipStyle() {
      return `left: ${this.tooltipPosition.left}px; top: ${this.tooltipPosition.top}px;`;
    },
    clientId() {
      return this.file.client_id || this.details.client_id;
    },
    isLast() {
      return this.filesList.length - 1 === this.index;
    },
    fileExtenstion() {
      return this.file.extension ? `Plik ${this.file.extension.toUpperCase()}` : 'Brak';
    },
    fileType() {
      return this.file.type === 1 ? 'Katalog' : this.fileExtenstion;
    },
    fileMime() {
      return this.file.type === 1 ? 'folder' : this.file.extension;
    },
    fileMimeTypeData() {
      return getMimeTypeData(this.fileMime);
    },
    isActive: {
      get() {
        return this.selectedFiles.find(file => file.id === this.file.id);
      },
      set(value) {
        this.toggleSelected(value);
      },
    },
    checkboxDisabled() {
      return this.$route.name === 'files';
    },
    activeClass() {
      return this.isActive ? 'light-blue lighten-5' : '';
    },
    isAdmin() {
      return this.role === 'admin' || this.role === 'super-admin';
    },
    paddingClass() {
      return this.$vuetify.breakpoint.smAndDown ? 'px-0' : 'px-2';
    },
    checkboxMargin() {
      return this.$vuetify.breakpoint.smAndDown ? 'ml-3' : 'ml-4';
    },
  },
  methods: {
    ...mapActions('files', [
      'setSelectedItem',
      'removeSelectedItem',
      'setFileDragActivity',
    ]),
    createTooltip() {
      const tooltip = this.$refs.toolTipItem;
      if (tooltip) {
        const newTooltip = tooltip.cloneNode(true);
        newTooltip.classList.add(`neti-tooltip--${this.index}`);
        document.body.appendChild(newTooltip);
      }
    },
    showTooltip() {
      const container = this.$refs.nameContainer;
      const elemRect = container.getBoundingClientRect();
      const bodyRect = document.body.getBoundingClientRect();
      const offset = {
        top: elemRect.top - bodyRect.top,
        left: elemRect.left - bodyRect.left,
      };

      const thisTooltip = document.getElementsByClassName(`neti-tooltip--${this.index}`);
      if (thisTooltip.length > 0) {
        thisTooltip[0].style.left = `${offset.left}px`;
        thisTooltip[0].style.top = `${offset.top}px`;
        if (thisTooltip[0].classList.contains('neti-tooltip--disabled')) {
          thisTooltip[0].classList.remove('neti-tooltip--disabled');
        }
      }
    },
    hideTooltip() {
      const thisTooltip = document.getElementsByClassName(`neti-tooltip--${this.index}`);
      if (!thisTooltip[0].classList.contains('neti-tooltip--disabled') && thisTooltip.length > 0) {
        thisTooltip[0].classList.add('neti-tooltip--disabled');
      }
    },
    deleteTooltip() {
      const thisTooltip = document.getElementsByClassName(`neti-tooltip--${this.index}`);
      if (thisTooltip.length > 0) {
        thisTooltip[0].remove();
      }
    },
    toggleSelected(value) {
      if (value) {
        const file = {
          id: this.file.id,
          type: this.file.type,
        };
        this.setSelectedItem(file);
      } else {
        this.removeSelectedItem(this.file.id);
      }
    },
    openFolder() {
      const { query } = this.$route;
      const newQuery = {
        ...query,
      };
      this.$router.push({
        path: `/pliki/klient/${this.clientId}/katalog/${this.file.id}`,
        query: newQuery,
      });
    },
    clickItem() {
      if (this.file.type === 1) {
        this.openFolder();
      }
    },
    onFileDragOver(event) {
      this.setFileDragActivity(true);
      if (event.dataTransfer.types.includes('Files')) {
        event.dataTransfer.dropEffect = 'copy';
      } else {
        event.dataTransfer.dropEffect = 'none';
      }
      event.preventDefault();
    },
    onFileDragLeave() {
      this.setFileDragActivity(false);
    },
    async downloadFile() {
      if (this.file.type !== 1) {
        let file = await authorizeDownload(this.file.id);
        file = decodeUri(file.data.data.url);
        if (file) {
          downloadInit(file);
        }
      }
    },
  },
  beforeDestroy() {
    this.deleteTooltip();
  },
  mounted() {
    this.createTooltip();
  },
};
</script>
